import { OddsListType, PlayListType, SportListType } from 'types/wsSportType';

function processItem4([gid, gidM, playCode, playItemCode, playItemName, odds, showTitle, contentTitle, type, result, ratio, sort, strong]) {
    return {
        gid,
        gidM,
        playCode,
        playItemCode,
        playItemName,
        odds,
        isClose: parseFloat(odds) === 0,
        showTitle,
        contentTitle,
        type,
        result,
        ratio,
        sort,
        strong,
        id: `${gid}_${gidM}_${playCode}_${playItemCode}`,
    };
}

function processItem3(item3, bettingSource) {
    if (Array.isArray(item3) && item3.length > 0) {
        return {
            gid: item3[0],
            gidM: item3[1],
            playCode: item3[2],
            playName: item3[3],
            playShowName: item3[4],
            sportMatchType: item3[5],
            sportMatchTypeName: item3[6],
            sportHalf: item3[7],
            sportHalfSort: item3[8],
            sportHalfName: item3[9],
            isMultiple: item3[10],
            isLock: item3[11],
            isQuickShow: item3[12],
            strong: item3[13],
            isIncludePrincipal: item3[14],
            isOddsConversion: item3[15],
            sort: item3[16],
            bettingSource: bettingSource,
            playItemList: Array.isArray(item3[17]) ? item3[17].map(processItem4) : [],
        };
    } else {
        return {};
    }
}

export function processItem2(item2) {
    if (Array.isArray(item2) && item2.length > 0) {
        return {
            gid: item2[0],
            gidM: item2[1],
            lid: item2[2],
            league: item2[3],
            nowSession: item2[4],
            categoryCode: item2[5],
            timer: item2[6],
            strong: item2[7],
            matchStartTime: item2[8],
            isCornerKick: item2[9],
            isPenaltyKick: item2[10],
            hname: item2[11],
            cname: item2[12],
            hscore: item2[13],
            cscore: item2[14],
            hteamLogo: item2[17],
            cteamLogo: item2[18],
            playList: Array.isArray(item2[15]) ? item2[15].map(item3 => processItem3(item3, 1)) : [],
            // playList2: Array.isArray(item2[16]) ? item2[16].map(item3 => item3.map(item4 => processItem3(item4, 2))) : [],
        };
    } else {
        return {};
    }
}

export function basketProgressText(processNum: number): string {
    let processNumObj = {
        3: '1Q',
        4: '2Q',
        15: '3Q',
        16: '4Q',
        21: '加时',
    };

    return processNumObj[processNum] || '';
}

export function transformDetailPlays(data: any[], hName: string, cName: string, gid: number): PlayListType[] {
    return (data ?? []).map((item: any[]) => {
        const [playCode, playName, oddsList, betPlayTitle, betPlayType, matchType, is_include_principal] = item;
        return {
            playCode,
            betPlayTitle: betPlayTitle?.replace(/{h}/g, hName)?.replace(/{c}/g, cName),
            betPlayType,
            oddsList: transformOddsList(oddsList, hName, cName, is_include_principal),
            playName,
            matchType,
            is_include_principal,
            gid
        };
    });
}

export function transformOddsList(data: any[], hName: string, cName: string, data2: number): OddsListType[] {
    return (data ?? []).map((item2: any[]) => {
        const [playItemCode, result, itemId, odds, status, showTitle, betShowTitle, gridType] = item2;
        return {
            betShowTitle: betShowTitle,
            itemId,
            odds,
            playItemCode,
            result,
            status: Number(odds) === 0 && Number(status) === 1 ? 2 : status,
            oldStatus: status,
            compare: 0,
            showTitle: showTitle?.replace(/{h}/g, hName)?.replace(/{c}/g, cName),
            gridType: gridType,
            is_include_principal: Number(data2 || 0),
        };
    });
}

export function transformOddsGroupByList(data: OddsListType[]) {
    const hasGroupingData = data.some(item => item.gridType !== null);

    if (!hasGroupingData) {
        return [data];
    }

    const groupedData: { [key: number]: OddsListType[] } = {};
    data.forEach(item => {
        if (item.gridType !== null) {
            if (!groupedData[item.gridType!]) {
                groupedData[item.gridType!] = [];
            }
            groupedData[item.gridType!].push(item);
        }
    });

    return Object.values(groupedData);
}

export function setGridStyle(list: OddsListType[][]): string {
    if (list.length > 1) {
        const typeSet = new Set((list || [])?.flatMap(item => item)?.flatMap(item => item.gridType));
        // 两列
        const twoGrid = [4, 5, 6, 7, 8, 9, 10, 14, 15].some(value => typeSet.has(value));
        if (twoGrid) {
            return `grid grid-2 ${typeSet.has(10) || typeSet.has(34) ? 'lastOnly' : ''}`;
        }
        
        // 三列
        const threeGrid = [1, 2, 3, 11, 12, 13, 31, 32, 33].some(value => typeSet.has(value));
        if (threeGrid) {
            if (typeSet.has(34)) {
                return 'grid grid-2 lastTwoOnly';
            }
            return `grid grid-3`;
        }
    }
    return '';
}

export function transformDetailList(data: any[]): SportListType {
    const hName = data[3];
    const cName = data[4];

    return {
        gid: data[0],
        hid: data[1],
        cid: data[2],
        hName: data[3],
        cName: data[4],
        hIcon: data[5],
        cIcon: data[6],
        matchStartTime: data[7],
        playCount: data[8],
        timer: data[9],
        now_score: data[10],
        half_score: data[11],
        isHalf: data[12],
        playList: transformDetailPlays(data[13], hName, cName, data[0]),
        leagueCode: data[14],
        leagueName: data[15],
        categoryCode: data[16],
        nowCornerScore: data[17],
        nowYellowScore: data[18],
        nowRedScore: data[19],
        nowOvertimeScore: data[20],
        status: data[21],
        basketProgressText: basketProgressText(data[12]),
    };
}
